import { createLogger } from "vue-logger-plugin";
import constants from "@/utils/constants";

// create logger with options
// Log output will look like: [LogLevel] [File:function:line-number] output
const logger = createLogger({
  level: process.env.NODE_ENV === constants.ENVS.PROD ? "warn" : "debug",
  callerInfo: true,
});

export default logger;
